import Richtext from './richtext';
import Button from './button';
import Media from './media';

type Tile = { id: string; image?: Media; icon?: Media; description?: Richtext };

const formatNumber = (num: any) =>
  num && !Number.isNaN(num) ? num.toFixed(2) : null;
export class Carousel {
  cursor?: Button;
  tiles?: Tile[];
  loop: boolean;
  quantityTiles: any;

  constructor(props: any) {
    const items =
      props?.tilesCollection?.items?.length > 3
        ? props?.tilesCollection?.items
        : [...props?.tilesCollection?.items, ...props?.tilesCollection?.items];

    const slides = items.map((slide: any, index: number) => ({
      id:
        slide.sys && slide.sys.id
          ? `${slide.sys.id}-${index}`
          : `${slide.title}-${index}`,
      image: slide.mainMedia ? new Media(slide.mainMedia) : null,
      icon: slide.secondaryImage ? new Media(slide.secondaryImage) : null,
      description: slide.description ? new Richtext(slide.description) : null
    }));

    this.tiles = slides || [];
    this.cursor = props.cursor ? new Button(props.cursor) : undefined;
    this.loop = props.loopTiles;
    this.quantityTiles = props.quantityOfTiles
      ? {
          MOBILE: formatNumber(props.quantityOfTiles.MOBILE),
          TABLET: formatNumber(props.quantityOfTiles.TABLET),
          DESKTOP: formatNumber(props.quantityOfTiles.DESKTOP)
        }
      : null;
  }
}

export default Carousel;
